import type { SVGProps } from 'react'
import { X } from 'lucide-react'
import { useAppShell } from '@/contexts/AppShellContext'
import { useI18n } from '@/i18n'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { BrandLogoMark } from '@/components/brand/BrandLogoMark'
import { DefendSphereAiLauncher } from '@/components/defendsphere-ai'

/** Three-bar menu (open drawer) — brand blue #3589CF */
function MobileMenuOpenIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3999 15.2C10.3999 14.5373 10.9372 14 11.5999 14H28.3999C29.0626 14 29.5999 14.5373 29.5999 15.2C29.5999 15.8627 29.0626 16.4 28.3999 16.4H11.5999C10.9372 16.4 10.3999 15.8627 10.3999 15.2ZM10.3999 20C10.3999 19.3373 10.9372 18.8 11.5999 18.8H28.3999C29.0626 18.8 29.5999 19.3373 29.5999 20C29.5999 20.6627 29.0626 21.2 28.3999 21.2H11.5999C10.9372 21.2 10.3999 20.6627 10.3999 20ZM11.5999 23.6C10.9372 23.6 10.3999 24.1373 10.3999 24.8C10.3999 25.4627 10.9372 26 11.5999 26H28.3999C29.0626 26 29.5999 25.4627 29.5999 24.8C29.5999 24.1373 29.0626 23.6 28.3999 23.6H11.5999Z"
        fill="#3589CF"
      />
    </svg>
  )
}

/**
 * Fixed top bar with menu toggle — visible below desktop (&lt; 1280px): tablet + mobile.
 */
export function MobileAppHeader() {
  const isDesktop = useMediaQuery('(min-width: 1280px)')
  const { menuOpen, openMenu, closeMenu } = useAppShell()
  const { t } = useI18n()

  if (isDesktop) {
    return null
  }

  return (
    <header className="mobile-app-header">
      <button
        type="button"
        className="mobile-app-header__menuBtn"
        aria-expanded={menuOpen}
        aria-controls="app-nav-drawer"
        aria-label={
          menuOpen
            ? t('buttons.closeNavigationMenu', 'Close menu')
            : t('buttons.openNavigationMenu', 'Open menu')
        }
        onClick={() => (menuOpen ? closeMenu() : openMenu())}
      >
        {menuOpen ? (
          <X className="mobile-app-header__icon" aria-hidden />
        ) : (
          <MobileMenuOpenIcon className="mobile-app-header__menuOpenSvg" />
        )}
      </button>
      <div className="mobile-app-header__brand">
        <BrandLogoMark />
        <span className="mobile-app-header__title">{t('app.name', 'DefendSphere')}</span>
      </div>
      <DefendSphereAiLauncher placement="mobile-header" />
    </header>
  )
}
